export enum LegacyFeldTyp {
  TEXT = 1,
  CHECKBOX,
}
